<template>
  <el-card
    class="moving-card"
    :body-style="{ height: '100%', 'background-color': 'var(--nxt-color-lightest-blue)'}">
    <div class="moving-card__body">
      <div>
        <font-awesome-icon
          :icon="['fal', 'home-lg-alt']"
          size="2x"
          class="descriptifs__cards__icon"
        />
      </div>
      <h3 class="moving-card__body__h3 center-v-h">
        {{ $t('home.descriptifsCards.myMove') }}
      </h3>
      <p class="moving-card__body__text to-upper-case center-v-h">
        {{ moving }}
      </p>
      <div class="moving-card__body__button">
        <router-link :to="{ name: 'details' }">
          <el-button
            type="primary">
            {{ $t('home.descriptifsCards.details') }}
          </el-button>
        </router-link>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'pinia';
import { useDemandStore } from '@/stores';

export default {
  name: 'movingCard',
  computed: {
    ...mapState(useDemandStore, ['demand']),
    moving() {
      return `${this.demand.from_address.city} => ${this.demand.to_address.city}`;
    },
  },
};
</script>

<style scoped lang="scss">
.moving-card {
  margin-bottom: 20px;
  border-radius: 0;
  border: none;
  @include breakpoint(tablet) {
    border-radius: 4px;
    margin: 0;
  }
  &__body {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: 0;
    font-size: 18px;
    height: 100%;
    &__h3 {
      margin-top: 10px;
      margin-bottom: 0;
      height: 60px;
    }
    &__text {
      margin: 10px 0;
      font-size: 16px;
      flex: 1 1;
    }
  }
}
</style>
